import createReactComponent from '../createReactComponent';
export default createReactComponent('tally-three', 'TallyThree', [["path",{"d":"M4 4v16M9.333 4v16m5.334-16v16","key":"svg-0"}]]);